import React from 'react';
import styled from 'styled-components';

const BankNotListedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 90vw;
  iframe {
    width: 100%;
    height: 90vh;
    border: none;
  }
`;

const EmandateIframeModal = ({ url, id = 'emandate_iframe' }) => {
  return (
    <BankNotListedWrapper>
      <iframe id={id} title="Razorpay emandate" alt="razorpay emandate" src={url}></iframe>
    </BankNotListedWrapper>
  );
};

export default EmandateIframeModal;
